export const DEFAULT_USER_AUTH = {
    userId: 0,
    email: "",
    username: "",
    authenticated: false,
    admin: false,
};

export const maxFileSize = 1024 * 1024 * 500;

export const requestDetailsMapping = {
    email: "Email",
    full_name: "Full Name",
    location: "Place and Country",
    gender: "Gender",
    profession: "Qualification and Profession",
    languages_speak: "Spoken Languages",
    posts_frequency: "How many days per week can you consistently upload posts?",
    social_media_link:
        "Do you have any existing social media dawah channels? If yes, please provide the links?",
    invitee_information:
        "Who invited you to Emaan Reviver? kindly mention their email or Instagram profile link or any other contact details",
    practice_islam: "Are you upon the Manhaj [methodology] of the Salaf-e-Saliheen?",
    resources:
        "Please provide the names of the Islamic scholars you follow and their YouTube channel links. This is mandatory for validating your profile. Submissions without scholar details and their YouTube channel links will not be processed. This helps us understand your methodology of learning and practising Islam",
    expectations: "What are your expectations from the Emaan Reviver app?",
    rate_your_experience: "How would you rate your experience with our form submission?",
    islamic_aqeeda: "Briefly describe your Islamic Aqeeda [belief] in a few words?",
    content_authenticity:
        "Why do you believe it's important to verify the authenticity of content before uploading it on online platforms?",
    specific_resources:
        "Which specific resources do you refer to for verifying the authenticity of Islamic content?",
    believes_principles:
        "In your exploration of knowledge and practice of Islam, which scholarly perspective or school of thought aligns closely with your beliefs and principles?",
    scholars:
        "Which respected Scholars or Ustadhs have been instrumental in shaping your understanding and providing guidance in your pursuit of Islamic knowledge?",
    scholar_reasons:
        "Can you explain why you think those Scholars or Ustadhs played a key role in helping you understand and learn about Islam?",
    scholars_social_media_links:
        "Please provide links to their social media profiles, online resources, or any video links that showcase the teachings and insights of the respected Scholars or Ustadhs you mentioned?",
    authenticity_challenges:
        "In the age of misinformation, how do you tackle challenges to authenticity and ensure the content aligns with Islamic Shariyah?",
};
